<template>
    <div class="video-animated-section" ref="section">
        <div class="video-animated-section__video-container" ref="videoContainer">
            <video ref="video" :src="videoSrc" autoplay loop muted playsinline></video>
        </div>
        <div class="wrap wrap-lg">
            <div class="text fade-in">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
    name: 'VideoAnimatedSection',
    props: {
        videoSrc: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.initAnimation()
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
        ScrollTrigger.getAll().forEach(st => st.kill())
    },
    methods: {
        initAnimation() {
            const start = window.innerWidth > 767 ? 'top 80%' : 'top 90%'
            const end = window.innerWidth > 767 ? 'top 20%' : 'top 30%'

            gsap.to(this.$refs.videoContainer, {
                scrollTrigger: {
                    trigger: this.$refs.section,
                    start: start,
                    end: end,
                    scrub: 1,
                    invalidateOnRefresh: true
                },
                scale: 1.4284
            })
        },
        handleResize() {
            ScrollTrigger.refresh()
        }
    }
}
</script> 